export const TAB_CA = 'geographical/CA';
export const TAB_SOLD = 'geographical/SOLD';
